export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvFooter.vue?vue&type=template&id=343501b4&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvFooter.vue?vue&type=template&id=343501b4&lang=pug&
// module id = 95
// module chunks = 0 1